import React, { useEffect, useState } from "react";
import "../../assets/css/menu-mundial.css";

interface TopButton {
  id: number;
  text: string;
  url_anchor: string;
}

interface MenuMundialComponentProps {
  visibleHeight: number;
  topButtons: TopButton[];
}

const MenuMundialComponent: React.FC<MenuMundialComponentProps> = ({
  visibleHeight,
  topButtons
}) => {
  const [activeSection, setActiveSection] = useState<string>("");

  useEffect(() => {
    const handleScroll = () => {
      let currentActiveId = "";

      for (let i = topButtons.length - 1; i >= 0; i--) {
        const button = topButtons[i];
        const elementId = button.url_anchor.startsWith('#') ? button.url_anchor.substring(1) : button.url_anchor;
        const element = document.getElementById(elementId);

        if (element) {
          const scrollY = window.scrollY + 100;
          if (scrollY >= element.offsetTop) {
            currentActiveId = button.url_anchor;
            break;
          }
        }
      }

      setActiveSection(currentActiveId);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, [topButtons]);

  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, anchor: string) => {
    e.preventDefault();
    const elementId = anchor.startsWith('#') ? anchor.substring(1) : anchor;
    const element = document.getElementById(elementId);

    if (element) {
      const offsetTop = element.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({
        top: offsetTop,
        behavior: "smooth"
      });
      setActiveSection(anchor);
    }
  };

  if (!topButtons || topButtons.length === 0) {
    return null;
  }

  return (
    <>
      {visibleHeight <= 0 && <div style={{ minHeight: '60px', height: 'auto', width: '100%' }}></div>}
      <div
        className="menu-mundial-component shadow-sm"
        style={
          visibleHeight <= 0
            ? { position: 'fixed', top: '0px', width: '100%', zIndex: 999, left: 0 }
            : { top: `${visibleHeight}px` }
        }
      >
        <div className="menu-mundial-container">
          {topButtons.map((button) => (
            <a
              key={button.id}
              href={button.url_anchor}
              className={`menu-mundial-btn ${activeSection === button.url_anchor ? "active" : ""}`}
              onClick={(e) => handleScrollTo(e, button.url_anchor)}
            >
              {button.text}
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default MenuMundialComponent;